/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()

// FK 01.11.26: Filter ohne Standard-Preisbereich und leeres sort_by in die URL schreiben
// (sonst erscheint bei jedem Filter ein Preis-Chip "CHF 0–max")
window.fkCleanFilterParams = (form, params) => {
    if (!params.get('sort_by')) params.delete('sort_by')
    const slider = form.querySelector('.filter-price-group-slider')
    const max = slider ? Number(slider.dataset.rangeMax) : null
    const gte = Number(params.get('filter.v.price.gte'))
    const lte = Number(params.get('filter.v.price.lte'))
    if (!gte) params.delete('filter.v.price.gte')
    if (max !== null && (!lte || lte >= max)) params.delete('filter.v.price.lte')
    return params
}
window.onChangeCollectionFilter = async (input, event) => {
    const form = input.closest('form')
    const params = window.fkCleanFilterParams(form, new URLSearchParams(new FormData(form)))
    const qs = params.toString()
    window.history.replaceState({}, '', `${window.location.pathname}${qs ? '?' + qs : ''}`)
    await loadCollection()
}
